export default {
    label_apply: 'Apply',
    chart_information: 'Chart information',
    percentile_50: '50% of tasks were solved in {value} {dayLabel} or less',
    percentile_85: '85% of tasks were solved in {value} {dayLabel} or less',
    percentile_95: '95% of tasks were solved in {value} {dayLabel} or less',
    percentile_short_50: '50% in {value} {dayLabel}',
    percentile_short_85: '85% in {value} {dayLabel}',
    percentile_short_95: '95% in {value} {dayLabel}',
    label_days: 'Days',
    label_count: 'Count',
    label_pc: 'pc',
    label_cfd_nodata: 'There are no tasks matching the filter conditions',
    label_save: 'Save',
    label_delete: 'Delete',
    label_name: 'Name',
    label_description: 'Description',
    label_edit: 'Edit',
    label_reset: 'Reset',
    label_confirm: 'Confirm',
    label_close: 'Close',
    label_cancel: 'Cancel',
    label_save_changes: 'Save changes',
    label_clear: 'Clear',
    label_rename: 'Rename',
    label_yes: 'Yes',
    label_no: 'No',
};
